module.exports = __webpack_public_path__ + "img/SKMJ_up1.4f91973b.jpg";